import jQuery from 'jquery';

export function stripHTML(dirtyString) {
  return jQuery('<div/>')
    .html(dirtyString)
    .text();
}



// WEBPACK FOOTER //
// ./src/utils/html.js